export default "__VITE_ASSET__CTp1XW$0__"